export class ModuleConfiguration {
  static moduleName = 'extracts';
}



// WEBPACK FOOTER //
// ./src/app/extracts/extracts.module.config.ts